import { memo } from 'react';
const SvgMoreHorizontal = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    className="more-horizontal_svg__feather more-horizontal_svg__feather-more-horizontal"
    viewBox="0 0 24 24"
    {...props}
  >
    <circle cx={12} cy={12} r={1} />
    <circle cx={19} cy={12} r={1} />
    <circle cx={5} cy={12} r={1} />
  </svg>
);
const Memo = memo(SvgMoreHorizontal);
export default Memo;
